module.exports = __webpack_public_path__ + "media/images/lb/011-5211f5d04def40da94694515e9b46321.svg";